<div class="tag-popover-container" cdkOverlayOrigin #popoverOrigin="cdkOverlayOrigin">
  <button
    type="button"
    class="tag-popover-trigger"
    (mouseenter)="onTriggerMouseEnter()"
    (mouseleave)="onTriggerMouseLeave()"
    (click)="onTriggerClick($event)"
    [attr.aria-label]="'service-request.tag.manage' | translate"
  >
    <svg
      class="tag-popover-trigger-icon"
      viewBox="0 0 16 16"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M2.5 3.25h4.7l6.05 6.05a1.5 1.5 0 0 1 0 2.12l-1.83 1.83a1.5 1.5 0 0 1-2.12 0L3.25 7.2V3.25Z" />
      <circle cx="5.45" cy="5.45" r=".8" />
    </svg>
  </button>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="popoverOrigin"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayOpen]="isPopoverOpen || !!activeTagType"
  [cdkConnectedOverlayHasBackdrop]="false"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="8"
  [cdkConnectedOverlayOffsetY]="6"
  [cdkConnectedOverlayOffsetX]="2"
>
  <div
    class="tag-popover-panel"
    (mouseenter)="onPopoverMouseEnter()"
    (mouseleave)="onPopoverMouseLeave()"
  >
    <h3 class="tag-popover-title">{{ 'service-request.tag.popover-title' | translate }}</h3>

    <div class="tag-popover-divider"></div>

    <p class="tag-popover-section-label">{{ 'service-request.tag.added' | translate }}</p>

    <app-driveb-tag-list
      [showTitle]="false"
      [tags]="tags"
      [maxVisible]="5"
      [removable]="true"
      (remove)="onRemoveTag($event)"
    ></app-driveb-tag-list>

    <div class="tag-popover-divider tag-popover-divider--bottom"></div>

    <p class="tag-popover-section-label">{{ 'service-request.tag.new' | translate }}</p>

    <div class="tag-popover-new-tag-actions">
      <button
        *ngIf="activeTagType !== 'INTERNAL'"
        type="button"
        class="tag-pill-action tag-pill-action--internal"
        (click)="onStartAddTag('INTERNAL')"
      >
        <span>{{ 'service-request.tag.internal' | translate }}</span>
        <span class="tag-pill-action-icon" aria-hidden="true">+</span>
      </button>

      <div
        *ngIf="activeTagType === 'INTERNAL'"
        class="tag-pill-action tag-pill-action--internal tag-pill-action--editing"
      >
        <input
          #internalTagInput
          type="text"
          class="tag-pill-action-input"
          [value]="newTagName"
          [placeholder]="'service-request.tag.placeholder' | translate"
          (input)="onTagInput(internalTagInput.value)"
          (keydown)="onTagInputKeydown($event)"
          (blur)="cancelAddTag()"
        />
      </div>

      <button
        *ngIf="activeTagType !== 'PUBLIC'"
        type="button"
        class="tag-pill-action tag-pill-action--public"
        (click)="onStartAddTag('PUBLIC')"
      >
        <span>{{ 'service-request.tag.external' | translate }}</span>
        <span class="tag-pill-action-icon" aria-hidden="true">+</span>
      </button>

      <div
        *ngIf="activeTagType === 'PUBLIC'"
        class="tag-pill-action tag-pill-action--public tag-pill-action--editing"
      >
        <input
          #publicTagInput
          type="text"
          class="tag-pill-action-input"
          [value]="newTagName"
          [placeholder]="'service-request.tag.placeholder' | translate"
          (input)="onTagInput(publicTagInput.value)"
          (keydown)="onTagInputKeydown($event)"
          (blur)="cancelAddTag()"
        />
      </div>
    </div>

    <div class="tag-popover-suggestions" *ngIf="suggestions.length">
      <button
        *ngFor="let tag of suggestions"
        type="button"
        class="tag-popover-suggestion"
        (mousedown)="$event.preventDefault()"
        (click)="onSuggestionSelected(tag)"
      >
        {{ tag.name }}
      </button>
    </div>
  </div>
</ng-template>
